import {classNames, Fragment, Highlighter, observer, Popover2, React, useCallback, useMemo} from '@api'
import {Button, HTMLSelect, Menu, MenuItem, Popover} from '@blueprintjs/core'
import {Select} from '@blueprintjs/select'
import {useFilterStore} from '@modules'
import * as css from './BoardSectionFilterDropdown.css'
import {ISectionConfig, useCatalog} from '@stores'

export const BoardSectionFilterDropdown = observer<{ hidden?, className?:string }>(function BoardSectionFilterDropdown({hidden, className}) {
  const filter = useFilterStore(),
    {state, strings, state: {section}, workspaceConfig: {sections, title, _id}} = filter,
    options = useMemo(() => _.uniq([strings.all, ...(sections ?? []).map(s => s.visible !== false && s.label).filter(_.identity)]), [sections, title]),
    onChange = useCallback(({currentTarget: {value}}) => {
      state.section = value == strings.all ? '' : value == title ? _id : sections.find(f => f.label == value).id
    }, [title, sections]),
    selectionSection: ISectionConfig = (sections ?? []).find(f => f.id == section)

  if (options.length <= 2) { return null }

  return <Fragment>
    <div className={classNames(css.selectWrapper, className)}>
      <HTMLSelect
        className={css.root}
        options={options}
        onChange={onChange}
        value={!section ? strings.all : (selectionSection?.label ?? (section == _id ? title : '...'))}/>
    </div>
    {(!selectionSection?.viewOptions?.nestedView || !section || section === strings.all) && <SubSectionFilterDropDown section={selectionSection}/>}
  </Fragment>
})

const SubSectionFilterDropDown = observer<{ section?: ISectionConfig }>(function SubSectionFilterDropDown({section}) {
  const {sectionValuesFor, filter: {strings, state, state: {sub}}} = useCatalog(),
    values = sectionValuesFor(section?.id) ?? [],
    options = [...values.map(val => val.key)],
    onChange = (e) => {
      const {textContent} = e.currentTarget
      const val = textContent.replace('tick', '').replace('blank', '')
      !_.isEmpty(val) && (state.sub.includes(val) ? _.remove(sub, s => s === val) : state.sub = [...state.sub, val])
    },
    onClear = useCallback(({}) => {state.sub = []}, [options])

  if (values.length === 0) return null

  return <Popover2 minimal
                  content={<Menu>
    {options.map((option, i) => <MenuItem key={i} icon={sub?.includes(option) ? 'tick' : 'blank'} shouldDismissPopover={false} onClick={onChange} aria-valuetext={option} text={option}></MenuItem>)}
    {sub.length ? <Fragment>
      <Menu.Divider/>
      <MenuItem icon={'clean'} onClick={onClear} text={strings.clear}></MenuItem>
    </Fragment> : null}
  </Menu>} position={'bottom'}>
    <Button className={css.dropdown_button} text={sub.length ? sub.join(', ') : strings.all}/>
  </Popover2>
})

const BoardSectionSelect = Select.ofType<ISectionConfig>()

export const BoardSectionFilterDropdown2 = observer<{ hidden? }>(({hidden}) => {
  const filter = useFilterStore(),
    {state, strings, state: {section}, workspaceConfig: {sections, _id, title}} = filter,
    items: any = useMemo((() => [{label: strings.all, id: ''}, {label: title, id: _id}, ...sections]), sections)

  return <BoardSectionSelect
    className={css.boardSelect}
    items={items}
    onItemSelect={e => state.section = e.id}
    itemPredicate={(query, section, _index, exactMatch) => {
      const normalizedTitle = section.label.toLowerCase(),
        normalizedQuery = query.toLowerCase()

      if (exactMatch) {
        return normalizedTitle === normalizedQuery
      } else {
        return normalizedTitle.indexOf(normalizedQuery) >= 0
      }
    }}
    itemRenderer={(section, {handleClick, modifiers, query}) => {
      if (!modifiers.matchesPredicate) {
        return null
      }

      const searchWords = query.split(' ')

      return <MenuItem key={section.id}
                       onClick={handleClick}
                       active={modifiers.active}
                       icon={section.id == state.section ? 'tick' : 'blank'}
                       disabled={modifiers.disabled}
                       shouldDismissPopover={false}
                       text={<div className={css.selectMenuItem}><span className={css.section}><Highlighter textToHighlight={section.label} searchWords={searchWords}/></span></div>}/>
    }}
  >
    <Button text={items.find(f => f.id == state.section)?.label}
            minimal
            rightIcon='double-caret-vertical'/>
  </BoardSectionSelect>
})



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/filters/components/internal/BoardSectionFilterDropdown.tsx